export const useFeedView = () => {
  const feedStore = useFeedStore();

  const getDelayStr = (diff: number) => {
    const delayInMinutes = Math.floor(diff / (60 * 1000));
    const delayInHours = Math.floor(diff / (60 * 60 * 1000));
    const delayInDays = Math.floor(diff / (24 * 60 * 60 * 1000));

    if (delayInDays > 1) return `${delayInDays} jours`;
    if (delayInDays > 0) return `${delayInDays} jour`;
    if (delayInHours > 1) return `${delayInHours} heures`;
    if (delayInHours > 0) return `${delayInHours} heure`;
    if (delayInMinutes > 1) return `${delayInMinutes} minutes`;
    return `${delayInMinutes} minute`;
  };
  const feeds = computed(() =>
    feedStore.feeds.map((feed) => {
      const diff = new Date().getTime() - new Date(feed.date).getTime();
      return {
        ...feed,
        delayStr: getDelayStr(diff),
      };
    })
  );

  const _removeIds = (lFeeds: FeedSchema[]): string => {
    return lFeeds.map((feed) => feed.id).join('-');
  };

  const filterFeeds = (
    minDate: Date,
    idsToRemove: string = ''
  ): FeedSchema[] => {
    return feeds.value
      .filter((feed) => {
        const dateFeed = new Date(feed.date);
        return dateFeed > minDate;
      })
      .filter((feed) => !idsToRemove.includes(feed.id));
  };

  const toDayfeeds = computed(() => {
    const date = new Date();
    const dayToTest = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );
    return filterFeeds(dayToTest);
  });

  const last7DaysFeeds = computed(() => {
    const date = new Date();
    const dayToTest = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate() - 7
    );
    return filterFeeds(dayToTest, _removeIds(toDayfeeds.value));
  });

  const last30DaysFeeds = computed(() => {
    const date = new Date();
    const dayToTest = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate() - 30
    );
    return filterFeeds(
      dayToTest,
      _removeIds([...toDayfeeds.value, ...last7DaysFeeds.value])
    );
  });

  const otherFeeds = computed(() => {
    const idsToRemove = _removeIds([
      ...toDayfeeds.value,
      ...last7DaysFeeds.value,
      ...last30DaysFeeds.value,
    ]);
    return feeds.value.filter((feed) => !idsToRemove.includes(feed.id));
  });

  return {
    otherFeeds,
    last30DaysFeeds,
    last7DaysFeeds,
    toDayfeeds,
    feeds,
  };
};
